<template>
  <div>
    <counting-approve-table v-show="activeKey===1" ref="list" :counting-types="countingTypes" :order-status="orderStatus" @getDetail="getDetail"/>
    <counting-approve-detail v-show="activeKey===2" ref="detail" :counting-types="countingTypes" :inventory-states="inventoryStates" :order-status="orderStatus" @back="back"/>
  </div>
</template>

<script>
import CountingApproveTable from '@/views/counting/counting_approve/CountingApproveTable.vue'
import CountingApproveDetail from '@/views/counting/counting_approve/CountingApproveDetail.vue'
import { getEnums } from '@/utils/util'

export default {
  name: 'TemporaryCounting',
  components: { CountingApproveTable, CountingApproveDetail },
  data() {
    return {
      activeKey: 1,
      orderStatus: [],
      inventoryStates: [],
      countingTypes: []
    }
  },
  created() {
    getEnums('OrderStatus').then(result => {
      this.orderStatus = result
      return getEnums('InventoryState')
    }).then(result => {
      this.inventoryStates = result
      return getEnums('CountingType')
    }).then(result => {
      this.countingTypes = result
    })
  },
  methods: {
    back() {
      this.activeKey = 1
      this.$refs.list.fetch()
    },
    getDetail(row) {
      this.activeKey = 2
      this.$refs.detail.refresh(row)
    }
  }
}
</script>